const lclExportChargesData1 = {
    initialLength: 14,
    preList: [{
            id: 1,
            chargeDescription: 'Pick-up Charges',
            currency: 'INR',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            onaccount: "On Your Account",
            // disabled: ['perCBM','perTon','maximum', 'minimum']
        },
        {
            id: 2,
            chargeDescription: 'Export Customs Clearance',
            currency: 'INR',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            onaccount: "On Your Account",
            disabled: ['perCBM','perTon','maximum', 'minimum']
        },
        {
            id: 3,
            chargeDescription: 'Origin Charges',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: 'INR',
            onaccount: "On Your Account",
        },
        {
            id: 4,
            chargeDescription: 'Origin Inland Haulage',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: 'INR',
            onaccount: "On Your Account",
        },
        {
            id: 5,
            chargeDescription: 'Ocean Freight',
            currency: 'USD',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            disabled: ['perShipment'],
            onaccount: "On Your Account",
        },
        {
            id: 6,
            chargeDescription: 'Hazardous Surcharge',
            currency: 'USD',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            disabled: ['perCBM','perTon','maximum', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 7,
            chargeDescription: 'Non-Stackable Surcharge',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: 'USD',
            onaccount: "On Your Account",
        },
        {
            id: 8,
            chargeDescription: 'Destination Inland Haulage',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },
        {
            id: 9,
            chargeDescription: 'Destination Charges',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },
        {
            id: 10,
            chargeDescription: 'Destination CFS Charges',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },
        {
            id: 11,
            chargeDescription: 'Import Customs Clearance',
            currency: '',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            disabled: ['perCBM','perTon','maximum', 'minimum'],
            onaccount: "On Your Account",
        },
        {
            id: 12,
            chargeDescription: 'Door Delivery Charges',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
            // disabled: ['perCBM','perTon','maximum', 'minimum']
        },{
            id: 13,
            chargeDescription: 'Terminal Handling Fees',
            perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        },{
            id: 14,
            chargeDescription: 'BL Fees',
           perCBM: 0,
            perTon: 0,
            minimum: 0,
            maximum: 0,
            currency: '',
            onaccount: "On Your Account",
        }
    ]
}
export default lclExportChargesData1